import takeOutMenu from '../../assets/menus/takeOutMenu.pdf';
import lunchMenu from '../../assets/menus/lunchMenu.pdf';
import dineInMenu from '../../assets/menus/dineInMenu.pdf';
import wineListMenu from '../../assets/menus/wineList.pdf';

const menus = {
  takeOut: takeOutMenu,
  dineIn: dineInMenu,
  wineList: wineListMenu,
  lunch: lunchMenu,
};

export default menus;
